import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import TextInput from "./TextInput";
import WizardFooter from "./WizardFooter";
import { felonyConsideration } from "../utils/surveyLogic";
import RadioInput from "./RadioInput";

export const fields = [
  "convicted_of_felony",
  "convictionMonth",
  "convictionYear",
  "releaseMonth",
  "releaseYear",
  "officer_name",
  "officer_phone",
  "work_release",
  "contact_felony",
  "contact_felony_statement",
];

const validate = (values, props) => {
  const errors = {};
  const phoneRegex = /^[-(). ]*(\d[-(). ]*){10,}$/;
  if (felonyConsideration(values)) {
    if (!values.work_release) {
      errors.work_release = props.allText.shared.required;
    } else if (values.officer_phone && !phoneRegex.test(values.officer_phone)) {
      errors.officer_phone = props.allText.shared.invalid_tel_number;
    } else if (!values.contact_felony) {
      errors.contact_felony = props.allText.shared.required;
    }
  }
  return errors;
};

export class WizardFormSection06c extends Component {
  componentDidMount() {
    const {
      fields: {
        convicted_of_felony,
        convictionMonth,
        convictionYear,
        releaseMonth,
        releaseYear,
        contact_felony_statement,
      },
      allText,
      handleSubmit,
    } = this.props;

    contact_felony_statement.autofill(allText.dol.contactFelonyStatement);
    if (
      !felonyConsideration({
        convicted_of_felony: convicted_of_felony.value,
        convictionMonth: convictionMonth.value,
        convictionYear: convictionYear.value,
        releaseMonth: releaseMonth.value,
        releaseYear: releaseYear.value,
      })
    ) {
      handleSubmit();
    }
  }

  render() {
    const {
      allText,
      fields: { officer_name, officer_phone, work_release, contact_felony },
      handleSubmit,
      previousPage,
    } = this.props;
    const text = { ...allText.shared, ...allText.section06c };
    const progress = 5;
    return (
      <form onSubmit={handleSubmit} className="form-horizontal">
        <div className="wizard-page-content">
          <div className="page-title-container">
            <span className="page-title underline">{text.title}</span>
            <span className="wizard-text question-text">{text.subtitle}</span>
          </div>
          <div className="primary-question">{text.primaryQuestion}</div>
          <div className="separator" />
          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="wizard-text">{text.question07}</div>
              <TextInput
                text={text}
                field={officer_name}
                placeholder={text.question07Placeholder}
              />
            </div>

            <div className="col-12 col-sm-6 big-form-margin">
              <div className="wizard-text">{text.question08}</div>
              <TextInput
                text={text}
                field={officer_phone}
                placeholder={text.question08Placeholder}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="wizard-text">{text.question09}</div>
              <RadioInput
                text={text}
                field={work_release}
                options={["yes", "no"]}
              />
            </div>
            <div className="col-12 col-sm-6">
              <div className="wizard-text">{text.question10}</div>
              <RadioInput
                text={text}
                field={contact_felony}
                options={["yes", "no"]}
              />
            </div>
          </div>
        </div>
        <WizardFooter
          text={text}
          previousPage={previousPage}
          progress={progress}
        />
      </form>
    );
  }
}

WizardFormSection06c.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection06c);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection06c.js